import {
  VISA_LIST_FAIL,
  VISA_LIST_REQUEST,
  VISA_LIST_SUCCESS,
  VISA_UPDATE_FAIL,
  VISA_UPDATE_REQUEST,
  VISA_UPDATE_RESET,
  VISA_UPDATE_SUCCESS,
} from "../constants/visaConstant";

export const listVisaDescriptionReducer = (state = {}, action) => {
  switch (action.type) {
    case VISA_LIST_REQUEST:
      return {
        loading: true,
      };
    case VISA_LIST_SUCCESS:
      return {
        loading: false,
        success: true,
        descriptions: action.payload,
      };

    case VISA_LIST_FAIL:
      return {
        loading: true,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export const visaDescriptionEditReducer = (state = {}, action) => {
  switch (action.type) {
    case VISA_UPDATE_REQUEST:
      return {
        loading: true,
      };
    case VISA_UPDATE_SUCCESS:
      return {
        loading: false,
        success: true,
      };
    case VISA_UPDATE_FAIL:
      return {
        loading: true,
        error: action.payload,
      };
    case VISA_UPDATE_RESET:
      return {
        loading: true,
        success: false,
      };
    default:
      return state;
  }
};
